export enum DialogEvent {
    OPEN_DIALOG = 'dialog:open',
    CLOSE_DIALOG = 'dialog:close',
}
